import _ from "lodash";
import React, { useMemo } from "react";
import CardHeader from "./common/CardHeader";
import CardSubheader from "./common/CardSubheader";
import CardPreviewImage from "./common/CardPreviewImage";
import CardFilterPills from "./common/CardFilterPills";
import constants from "../../config/constants";
import AudioPlayer from "../common/AudioPlayer";
import CardFooter from "./common/CardFooter";
import ShortFeedItem from "../common/ShortFeedItem";
import getEnvEndpoints from "../../utils/endpoints";
import { previewImageOfPost, mtStandardsBooks, appendEllipsis } from "../../utils/helper";

const endpoints = getEnvEndpoints();

const Audio = ({
  post,
  lookup,
  cardFilterSelected,
  canProceed,
  showPmbokModal,
  showFeedbackModal,
  isAuthenticated,
  playlists,
  showShareModal,
  feedbackSentContentKeys,
  fullcard,
  propGroup,
  userLikes,
  feedbacks,
  contentKey,
  id
}) => {
  const mainContent = useMemo(() => {
    return post.referenceFiles
      ? _.find(post.referenceFiles, {
        fileKey: constants.fileKey.mainContent,
      })
      : {};
  }, [post.referenceFiles]);

  const audioFileUrl = mainContent?.filePath
    ? mainContent?.filePath
    : endpoints.baseContentUrl + mainContent?.relativePath;
  const previewImage = previewImageOfPost(post);

  return (
    <>
      {fullcard ? (
        <div
          className={
            "flex border border-gray-500 rounded-sm mb-5 " +
            (post.status !== "Published" ? "bg-gray-400" : "bg-white")
          }
        >
          <div className="w-full">
            <CardHeader
              post={post}
              showPmbokModal={showPmbokModal}
              canProceed={canProceed}
              booksList={mtStandardsBooks(lookup, "MTStandardsGuide")}
            />

            <div className="px-5 mt-4">
              <div>
                <CardSubheader subheader={post.title} />
              </div>
              {previewImage && (
                <div>
                  <CardPreviewImage previewImage={previewImage?.filePath || previewImage} />
                </div>
              )}

              {mainContent && (
                <AudioPlayer url={audioFileUrl} canProceed={canProceed} post={post}/>
              )}

              <div
                className="text-base font-normal mb-2"
                dangerouslySetInnerHTML={{ __html: post.description && appendEllipsis(post.description) }}
              />

              <CardFilterPills
                post={post}
                lookup={lookup}
                canProceed={canProceed}
                cardFilterSelected={cardFilterSelected}
              />
            </div>

            <CardFooter
              post={post}
              showShareModal={showShareModal}
              showFeedbackModal={showFeedbackModal}
              canProceed={canProceed}
              isAuthenticated={isAuthenticated}
              feedbackSentContentKeys={feedbackSentContentKeys}
              playlists={playlists}
              propGroup={propGroup}
              userLikes={userLikes}
              feedbacks={feedbacks}
              contentKey={contentKey}
              id={id}
            />
          </div>
        </div>
      ) : (
        <ShortFeedItem post={post} />
      )}
    </>
  );
};

export default Audio;
